import { useEffect } from "react";

export function useInterval(interval: number, callback: () => void): void {
  useEffect(() => {
    const timer = setInterval(() => {
      void callback();
    }, interval);

    return () => clearInterval(timer);
  }, [interval, callback]);
}